import React from 'react';

const AWSDVAC02GuidePage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#F8F9FA', padding: 0, margin: 0, overflow: 'hidden' }}>
      {/* Embed the HTML file via iframe */}
      <iframe
        src="/aws-dva-c02.html"
        style={{
          width: '100vw',
          height: 'calc(100vh - 120px)',
          border: 'none',
          display: 'block',
          margin: 0,
          padding: 0
        }}
        title="AWS DVA-C02 Study Guide"
      />
    </div>
  );
};

export default AWSDVAC02GuidePage;